var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024.0005 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586.527 512.716l420.85-418.55c20.177-19.972 20.177-52.305 0-72.227-20.126-19.974-52.815-19.974-72.94 0l-420.49 418.19L89.57 15.707c-20.127-20.177-52.816-20.177-72.942 0-20.126 20.228-20.126 52.968 0 73.145l424.068 424.12-425.6 423.25c-20.127 19.972-20.127 52.305 0 72.227 20.125 19.973 52.814 19.973 72.94 0l425.24-422.892 422.69 422.74c20.125 20.177 52.814 20.177 72.94 0 20.126-20.228 20.126-52.968 0-73.145l-422.38-422.434z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel1);
export default __webpack_public_path__ + "static/media/cancel-1.d87ca045fd02413efdcd555c38510ef6.svg";
export { ForwardRef as ReactComponent };